module.exports = __webpack_public_path__ + "img/quote-right.847a04ae.svg";